@if (legacy) {
    <div class="d-inline-flex flex-row" [attr.data-sb-qa]="qaTag ? qaTag + '-legacy-container' : ''" [ngClass]="{'align-items-start w-100': alignment === IconBulletAlignment.Start, 'align-items-center': alignment === IconBulletAlignment.Center, 'align-items-end': alignment === IconBulletAlignment.End, 'align-items-baseline': alignment === IconBulletAlignment.Baseline, 'mw-100': textStyle===IconBulletTextStyle.BreakWord}">
        @if (icon) {
            <lib-icon [qaTag]="qaTag && icon ? qaTag + '-' + icon.Name + '-icon' : ''" class="scss-icon-line-height" [ngClass]="iconColorClass" [icon]="icon" [size]="size"></lib-icon>
        }
        <p class="ps-1" [ngClass]="{'text-wrap-pre': textStyle===IconBulletTextStyle.Pre, 'scss-icon-bullet-overflow-wrap': textStyle===IconBulletTextStyle.BreakWord}"><ng-content></ng-content></p>
    </div>
} @else {
    <div class="d-flex" [attr.data-sb-qa]="qaTag ? qaTag + '-container' : ''">
        @if (icon) {
            <div class="icon-bullet-prefix-icon">
                <lib-icon class="color-brand" [qaTag]="qaTag && icon ? qaTag + '-' + icon.Name + '-icon' : ''" [icon]="icon" [size]="IconSize.ExtraSmall"></lib-icon>
            </div>
        }
        <p [ngClass]="{'icon-bullet-label': !hasHover, 'icon-bullet-label-with-hover': hasHover}"><ng-content select="[label]"></ng-content></p>

        @if (suffixIcon) {
            <div class="icon-bullet-suffix-icon">
                <lib-icon [qaTag]="qaTag && suffixIcon ? qaTag + '-' + suffixIcon.Name + '-icon' : ''" [icon]="suffixIcon" [size]="IconSize.ExtraSmall"></lib-icon>
            </div>
        }
    </div>
}